import { render, staticRenderFns } from "./Collectors.vue?vue&type=template&id=7da5dfd8&"
import script from "./Collectors.vue?vue&type=script&lang=js&"
export * from "./Collectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports